import { useState } from 'react';
import { Button } from '@/components/ui/button';
import NotesModal from '@/components/staffing/modals/NotesModal';

export interface NotesColumnProps {
    Count: number;
    UserType: 'client' | 'staff' | 'applicant';
    Identifier: string;
    DisplayName: string;
}

const NotesColumn = ({ Count, UserType, Identifier, DisplayName }: NotesColumnProps) => {
    const [open, setOpen] = useState(false);
    const [localCount, setLocalCount] = useState(Count);

    return (
        <>
            <Button size="sm" variant="outline" onClick={() => setOpen(true)}>
                {localCount}
            </Button>
            <NotesModal
                open={open}
                onOpenChange={setOpen}
                identifier={Identifier}
                userType={UserType}
                displayName={DisplayName}
                onCountChange={setLocalCount}
            />
        </>
    );
};

export default NotesColumn;
